<template>
  <div class="md-layout-item md-size-100 md-medium-size-100">
    <md-card>
      <md-card-header
        class="md-card-header-icon"
      >
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          SafeCore Product Specifier
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-medium-size-100">
            <h3>SafeCore Product Specifier</h3>
            <p>This document is organized according to CSI MasterFormat and SectionFormat. Bold items require specifier selection. Convert bold to plain text, delete brackets, and removed specifier notes before publishing. This document is compatible with MASTERSPEC and SpecText editing tools.</p>
            <md-button @click="openContent" class="md-info">Download</md-button>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
  export default {
    data(){

    },
    methods: {
      openContent(){
        // this.downloadClicked = true;
        window.open("https://drive.google.com/file/d/11TcFPnK2y0Vgnk5dETC8hGpcbNjGFTTF/view?usp=sharing", '_blank')
      }
    }
  }
</script>
<style media="screen" lang="scss">
</style>
